import script from "./MyVacanciesTutorialOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./MyVacanciesTutorialOverlay.vue?vue&type=script&setup=true&lang=js"

import "./MyVacanciesTutorialOverlay.vue?vue&type=style&index=0&id=aadc11d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aadc11d2"]])

export default __exports__